var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-pdf"},[_c('embed',{staticClass:"pdf",attrs:{"id":"pdf","type":"application/pdf","src":(_vm.fileURL + "#" + _vm.rules)}})])}
var staticRenderFns = []

export { render, staticRenderFns }